/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Login\FormLogin\FormLogin.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday June 6th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 22nd January 2024 05:26:40
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import RouterPathResolver from 'Config/Router/RouterPathResolver';
import ServiceGeneral from 'Services/ServiceGeneral';
import UserService from 'Services/Users/UserService';
import Styles from "Content/Login/FormLogin/FormLogin.module.css";
import { useContext, useState, MouseEvent } from 'react';
import {Form, Button, Alert} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import { useAuth, AuthContext } from 'Router/AuthProvider';
import Cookie from "Cookies/CookieWrapper";
import CookiePathResolver from "Config/Cookies/CookiePathResolver";
import Config from 'Config/Config';
import { useUserContext } from 'Hooks/useUserContext';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField } from '@mui/material';
import translator from 'MultiLanguage/TranslationWrapper';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

type FormLoginPropsType = {
    returnUrl?: string | null,
};

function FormLogin(props: FormLoginPropsType) {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [loginError, setLoginError] = useState(false);
    const navigate = useNavigate();
    const {isConnected, login, logout} = useAuth();
    const val = useContext(AuthContext);
    const userCtx = useUserContext();
    const [showNewPassword, setShowNewPassword] = useState(false);
    const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
    const handleMouseDownNewPassword = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const HandleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (userName !== "" && password !== "") {
            let response: AxiosResponse | null = null;
            try {
                response = await UserService.login(userName, password);
                ServiceGeneral.handleAxiosResponse(response!);
            } catch (e: any) {
                setLoginError(true);
            }
            if (response?.status !== 200 && response?.status !== 304) {
                setLoginError(true);
            } else {
                Cookie.setCookie(CookiePathResolver.USER.TOKEN, response.data.token.access_token, Config.COOKIE.COOKIE_TIME_DAYS);
                if (response.data.token.refresh)
                    Cookie.setCookie(CookiePathResolver.USER.REFRESH_TOKEN, response.data.token.refresh, Config.COOKIE.COOKIE_TIME_REFRESH_DAYS);
                // userCtx.setName(`${response.data.FirstName} ${response.data.LastName?.at(0)}.`);
                // userCtx.setRole(response.data.Role);
                login(true);
                if (props.returnUrl !== undefined && props.returnUrl !== null)
                    navigate(props.returnUrl);
                else {
                    navigate(RouterPathResolver.pathEntryPoint.path, {replace: true});
                }
            }
        } else
            setLoginError(true);
    };

    return(
        <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center">
            <Form className={`${Styles.LoginForm}`} onSubmit={HandleSubmit}>
                <FormControl sx={{'& .MuiOutlinedInput-notchedOutline': {borderColor: "grey !important"}, '& .Mui-focused': {color: "black !important"}, width:"100%"}} variant="outlined" size="small">
                    <TextField
                        id="username-input"
                        label={translator.decode("login.placeholder.username")}
                        autoFocus
                        className={Styles.loginInput}
                        size="small"
                        type="email"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        required
                    />
                </FormControl>
                <FormControl sx={{'& .Mui-focused': {color: "black !important"}, width:"100%"}} variant="outlined" size="small">
                    <InputLabel htmlFor="outlined-adornment-password">{translator.decode("dynamic.password")}</InputLabel>
                    <OutlinedInput
                        sx={{'& .MuiOutlinedInput-notchedOutline': {borderColor: "grey !important"}, '& .MuiInputBase-inputAdornedEnd': {textAlign: "left"}}}
                        id="outlined-adornment-password"
                        className={`${Styles.passwordInput}`}
                        value={password}
                        inputProps={{minLength: 8}}
                        onChange={(e) => setPassword(e.target.value)}
                        type={showNewPassword ? 'text' : 'password'}
                        endAdornment={ <InputAdornment position="end">
                                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowNewPassword} onMouseDown={handleMouseDownNewPassword} edge="end" >
                                            {showNewPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                                        </IconButton>
                                    </InputAdornment>}
                        label={translator.decode("dynamic.password")}
                        required
                    />
                </FormControl>
                <Button title="Login" className='mb-3' type="submit">{translator.decode("login.send")}</Button>
            </Form>
            {loginError &&
                <Alert variant="danger" className="margined block">
                    <p className="mb-0">
                        {translator.decode("login.error_message")}
                    </p>
                </Alert>
            }
        </div>
    );
};

export default FormLogin;
